import SideCart from './SideCart';
customElements.define('side-cart', SideCart);
var cart = document.querySelector('side-cart');
var cartButton = document.querySelector('#side-cart-button');
function handleCartButtonClick(event) {
  event.preventDefault();
  if (cart && typeof cart.open === 'function') {
    cart.open('button');
  } else {
    console.error('The open method does not exist on the <side-cart> element.');
  }
}
if (!cart) {
  console.error('The <side-cart> element could not be found.');
}
if (!cartButton) {
  console.error('The button/anchor with id #side-cart-button could not be found.');
} else {
  cartButton.addEventListener('click', handleCartButtonClick);
}